/**
 * Checks if the browser supports ```ActiveXObject``` objects.
 *
 * @returns A ```Boolean```.
 * @ignore
 */
function supportsActiveXObject() {
    return "ActiveXObject" in self;
}
/**
 * Checks if the browser supports ```ArrayBuffers```.
 *
 * @returns A ```Boolean```.
 * @ignore
 */
function supportsArrayBuffer() {
    return "ArrayBuffer" in self;
}
/**
 * Checks if the browser supports ```Blob```s.
 *
 * @returns A ```Boolean```.
 * @ignore
 */
function supportsBlob() {
    function canConstructBlob() {
        try {
            new Blob();
            return true;
        }
        catch (error) {
            return false;
        }
    }
    return "FileReader" in self && "Blob" in self && canConstructBlob();
}
/**
 * Checks if the browser supports ```DOM Exception```.
 *
 * @returns A ```Boolean```.
 * @ignore
 */
function supportsDOMException() {
    function canConstructDOMException() {
        try {
            new DOMException();
            return true;
        }
        catch (error) {
            return false;
        }
    }
    return "DOMException" in self && canConstructDOMException();
}
/**
 * Checks if the browser supports the Fetch API.
 *
 * @returns A ```Boolean```.
 * @ignore
 */
function supportsFetch() {
    return "fetch" in self;
}
/**
 * Checks if the browser supports ```FormData``` objects.
 *
 * @returns A ```Boolean```.
 * @ignore
 */
function supportsFormData() {
    return "FormData" in self;
}
/**
 * Checks if the browser supports ```URLSearchParams```objects.
 *
 * @returns A ```Boolean```.
 * @ignore
 */
function supportsURLSearchParams() {
    return "URLSearchParams" in self;
}
/**
 * Checks if the browser supports ```XMLHttpRequest``` objects.
 *
 * @returns A ```Boolean```.
 * @ignore
 */
function supportsXMLHTTPRequest() {
    return "XMLHttpRequest" in self;
}
export { supportsActiveXObject, supportsArrayBuffer, supportsBlob, supportsDOMException, supportsFetch, supportsFormData, supportsURLSearchParams, supportsXMLHTTPRequest };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
